import { Mail, Phone, MapPin, MessageCircle, ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { COMPANY } from "../data/content";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
      <div className="grid gap-14 lg:grid-cols-12 lg:gap-20">
        <Reveal className="lg:col-span-5">
          <SectionLabel>Contact</SectionLabel>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight tracking-tight text-[#0A192F]">
            Request an inspection or a consultation.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-slate-600">
            Reach our inspection desk or HR team directly — our engineering
            executives respond worldwide.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <a
              href={`mailto:${COMPANY.emails[1]}?subject=Inspection%20Request`}
              data-testid="contact-email-cta"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#0A192F] px-8 py-4 text-xs font-bold uppercase tracking-[0.18em] text-white hover:bg-[#D4AF37] hover:text-[#0A192F] transition-colors duration-300"
            >
              Email Us
              <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-300" />
            </a>
            <a
              href={COMPANY.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-cta"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-300 px-8 py-4 text-xs font-bold uppercase tracking-[0.18em] text-[#0A192F] hover:border-[#D4AF37] hover:text-[#B08D2A] transition-colors duration-300"
            >
              <MessageCircle size={15} />
              WhatsApp
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-7">
          <div className="grid gap-px bg-slate-200 sm:grid-cols-2">
            <div className="bg-white p-8" data-testid="registered-office">
              <MapPin size={18} className="text-[#D4AF37]" />
              <h3 className="mt-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-[#0A192F]">
                Register Office
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">
                {COMPANY.registeredOffice}
              </p>
            </div>
            <div className="bg-white p-8" data-testid="corporate-office">
              <MapPin size={18} className="text-[#D4AF37]" />
              <h3 className="mt-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-[#0A192F]">
                Corporate Office
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">
                {COMPANY.corporateOffice}
              </p>
            </div>
            <div className="bg-white p-8" data-testid="contact-phones">
              <Phone size={18} className="text-[#D4AF37]" />
              <h3 className="mt-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-[#0A192F]">
                Mobile
              </h3>
              <div className="mt-3 flex flex-col gap-1.5">
                {COMPANY.phones.map((p) => (
                  <a
                    key={p}
                    href={`tel:${p}`}
                    className="text-sm text-slate-600 hover:text-[#B08D2A] transition-colors duration-300"
                  >
                    {p}
                  </a>
                ))}
              </div>
            </div>
            <div className="bg-white p-8" data-testid="contact-emails">
              <Mail size={18} className="text-[#D4AF37]" />
              <h3 className="mt-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-[#0A192F]">
                Email
              </h3>
              <div className="mt-3 flex flex-col gap-1.5">
                {COMPANY.emails.map((e) => (
                  <a
                    key={e}
                    href={`mailto:${e}`}
                    className="break-all text-sm text-slate-600 hover:text-[#B08D2A] transition-colors duration-300"
                  >
                    {e}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
